module.exports = __webpack_public_path__ + "img/malam.a8fa240e.png";